import { Injectable } from "@angular/core";
import { TranslateService as HostTranslateService, Lang } from "@root/shared/service/translate.service";
import { DateService } from "@root/shared/service/date.service";
import { HttpClient } from "@angular/common/http";
import _ from "lodash";
import * as moment from "moment-timezone";
import { StoreService } from "./shared/service/store.service";
import { Subject, BehaviorSubject } from "rxjs";
/** @WillDeprecated @deprecated 国际化的判断将逐渐交给app.service处理 */
@Injectable({
  providedIn: "root",
})
export class InternationalService {
  private readonly getApi = "/api/international/get";
  private readonly hostApi = "/api/config/hosts";
  private readonly initApi = "/api/international/init";
  /**
   * 是否是国际版
   * 主要的页面由system.service里的字段进行判断
   * 该字段用于在登录注册页面进行国际化判断
   * */
  private international = true;

  /** 系统所用语言 */
  private language;

  /** 系统时区 */
  private timezone;

  /** 系统所用币种 */
  private currency = "CNY";

  /** 日期的格式化 */
  private dateFormat;

  /** 时间的格式化 */
  private timeFormat;
  /** 下载app相应的数据 */
  private downloadInfo;

  onInternationalChange = new BehaviorSubject<boolean>(this.international);

  constructor(
    private http: HttpClient,
    private translateService: HostTranslateService,
    private dateService: DateService,
  ) {}

  /**
   * @deprecated
   *
   * 国际版的判断现在由app.service.ts来进行判断
   */
  isInternational() {
    return this.international;
  }

  setInternational(value: boolean) {
    this.international = value;
    this.onInternationalChange.next(value);
  }

  /** 切换语言之后调用 */
  setLanguage(id: number) {
    this.translateService.setCurrentLang(id);
  }

  setTimezone(timezone) {
    this.timezone = timezone;
  }

  setDownloadInfo(data) {
    this.downloadInfo = data;
  }

  getCurrency() {
    return this.currency;
  }

  setCurrency(currency) {
    this.currency = currency;
  }

  setDateFormat(format: number) {
    this.dateService.setDateFormat(format);
  }

  setTimeFormat(format: number) {
    console.log("🚀 ~ InternationalService ~ setTimeFormat ~ format:", format);
    this.dateService.setTimeFormat(format);
  }

  getTimezone() {
    return this.timezone;
  }

  getDownloadInfo() {
    return this.downloadInfo;
  }

  fetchInternationHost() {
    return this.http.get(this.hostApi);
  }

  initInternationalInfo() {
    this.http.get(this.getApi).subscribe((res) => {
      const info: any = _.get(res, "data.international");
      if (info) {
        this.setLanguage(info.language);
        this.setTimezone(info.timezone);
        this.setCurrency(info.currency);
        this.setDateFormat(info.date_format);
        this.setTimeFormat(info.time_format);
      } else {
        /** 国内版设置一个默认格式。tip: 理论上代码执行不到这里，国内版不会调用该方法 */
        this.setDateFormat(0);
        this.setTimeFormat(0);
      }
    });
  }

  reportInternationalInfo() {
    const utc = 0 - new Date().getTimezoneOffset() / 60;

    const timezone = moment.tz.guess();
    const timezone_utc = (utc > 0 ? "+" : "-") + utc;
    // const language = this.getSystemLanguage();
    // const language = this.translateService.getSystemLang();
    const language = this.translateService.getCurrentLang() === "cn" ? 0 : 2;

    let reported = false;
    const success = (params) => {
      console.log("success params: ", params);
      const latitude = params.coords.latitude;
      const longitude = params.coords.longitude;

      reported = true;
      this.requestInitInternational({ timezone, timezone_utc, language, latitude, longitude });
    };
    const error = (params) => {
      console.log("error params: ", params);
      reported = true;
      this.requestInitInternational({ timezone, timezone_utc, language });
    };

    // if (navigator.geolocation) {
    //   setTimeout(() => {
    //     if (!reported) {
    //       this.requestInitInternational({ timezone, timezone_utc, language });
    //     }
    //   }, 3000);
    //   navigator.geolocation.getCurrentPosition(success, error);

    // } else {
    // }
    this.requestInitInternational({ timezone, timezone_utc, language });
  }

  private requestInitInternational(params) {
    this.http.post(this.initApi, params).subscribe();
  }
}
